import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-multi-lang";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { StagingSlice, StagingState, staging } from "./StagingSlice";

// API
import StagingApi from "../../services/api/staging";

// Components
import TableActionBar from "../../components/TableActionBar/TableActionBar";
import { DashboardTable } from "../../components/Table/TablePagination";
import { EllipsisLoader, WhiteboxLoader } from "../../components/Loader/Loader";
import { ClassesMenu } from "../../components/PredefinedMenus/PredefinedMenus";
import {
  SelectField,
  PageSizeSelect,
} from "../../components/FormElements/FormElements";
import select_vector from "../../assets/images/vectors/select.svg";

import { years } from "../../services/hoc/helpers";
import { Link } from "react-router-dom";
//import AddRate from "../Clients/SearchClient/StagingProfle/AddStage"

import ClientStage_Groupe from "../Clients/SearchClient/StagingProfle/ClientStage_Groupe";
import { Col, Row } from "react-grid-system";
import { toast } from "react-toastify";

export default () => {
  // Translation
  const t = useTranslation();

  // Redux
  const dispatch = useDispatch();
  const state = useSelector(
    (state: { staging: StagingState }) => state.staging
  );

  // Hooks
  const [keyword, setKeyword] = useState<string>("");

  const [classType, setClassType] = useState<any>();
  const [year, setYear] = useState<number>(new Date().getFullYear());
  const [quarter, setQuarter] = useState<string>("");
  const [filter, setFilter] = useState<any>({
    label: "Staging",
    value: "",
  });

  const [allchecked, setAllChecked] = React.useState<string[]>([]);
  const [isOpenEditStage, setIsOpenEditStage] = useState<boolean>(false);
  const [selectedYear, setSelectedYear] = useState<any>();
  const [selectedQuarter, setSelectedQuarter] = useState<any>();
  const [showDetails, setShowDetails] = useState<{ [key: string]: boolean }>(
    {}
  );
  const [selectedType, setSelectedType] = useState<{ [key: string]: string }>(
    {}
  );
  const currentPage = state.currentPage;
  const lastPage = state.lastPage;
  const pagesCount = state.pagesCount;

  const [pageSize, setPageSize] = useState<number>(10);

  const [filtersComplete, setFiltersComplete] = useState(false);
  const requestIdRef = useRef(0);
  // API
  const ENDPOINTS = new StagingApi();

  // Table ref
  type TableHandle = React.ElementRef<typeof DashboardTable>;
  const tableRef = useRef<TableHandle>(null);

  // Search
  const search = (value: string) => {
    tableRef.current?.reset();
    dispatch(StagingSlice.actions.reset());
    setKeyword(value);
  };

  function handleChange(e: any) {
    //setAllChecked(e.target.checked);
    if (e.target.checked) {
      setAllChecked([...allchecked, e.target.value]);
    } else {
      setAllChecked(allchecked.filter((item: any) => item !== e.target.value));
    }

    if (allchecked) {
      //alert("The all checked values are"+ allchecked.join(" , "));
    }
  }

  // Fetch Data
  const fetchData = (page: number, size: number = pageSize) => {
    const currentRequestId = ++requestIdRef.current;
    dispatch(StagingSlice.actions.setCurrentPage(page));
    dispatch(StagingSlice.actions.setIsFetching(true));

    ENDPOINTS.staging_profile()
      .staging_list({
        page,
        page_size: size,
        class_type_id: classType?.value,
        year: year,
        quarter: quarter,
        keyword,
        filter_type: filter?.value,
      })
      .then((response: any) => {
        if (requestIdRef.current !== currentRequestId) {
          return;
        }
        if (response.data.data.clients != null) {
          let staging_list: staging[] = response.data.data.clients.map(
            (staging: any): staging => ({
              id: staging.id,
              class_type: staging.class_type_name,
              cif: staging.cif,
              name: staging.name,
              financial_status: staging.financial_status,
              stage: staging.stage_no,
              year: staging.year,
              quarter: staging.quarter,
              account_types: staging.account_types,
              // type_id: staging.id,
              currentPage: staging.currentPage,
              lastPage: staging.lastPage,
              pagesCount: staging.pagesCount,
              selectedClients: staging.selectedClients,
            })
          );
          dispatch(
            StagingSlice.actions.setPagesCount(
              Number(response.data.data.pages_count)
            )
          );
          dispatch(
            StagingSlice.actions.setStaging(
              staging_list.map((client) => ({
                ...client,
                isSelected: state.selectedClients.includes(client.id),
              }))
            )
          );
          // dispatch(
          //   StagingSlice.actions.setHasMore(
          //     page < Number(response.data.data.last_page)
          //   )
          // );
          //console.log(page !== Number(response.data.data.last_page))

          if (!state.isLoaded) dispatch(StagingSlice.actions.setIsLoaded(true));
          dispatch(StagingSlice.actions.setIsFetching(false));
        }
      });
  };

  useEffect(() => {
    const allFiltersSelected = classType && year && quarter && filter;
    dispatch(StagingSlice.actions.setFiltersComplete(!!allFiltersSelected));

    if (allFiltersSelected) {
      tableRef.current?.reset();
      dispatch(StagingSlice.actions.reset());
      fetchFilteredData();
    }
  }, [classType, year, quarter, filter]);

  const fetchFilteredData = () => {
    if (state.filtersComplete) {
      fetchData(1);
    }
  };

  interface tableDataType {
    [key: string]: { [key: string]: any };
  }
  const generateData: () => tableDataType = () => {
    let data: tableDataType = {};
    if (Array.isArray(state.staging_list)) {
      state.staging_list.forEach((staging, index) => {
        if (staging != null) {
          data[staging.id] = {
            actions1: (
              <div className="SimpleCheckbox">
                <input
                  type="checkbox"
                  value={staging.cif}
                  checked={state.selectedClients.includes(staging.cif)}
                  onChange={() =>
                    dispatch(
                      StagingSlice.actions.toggleClientSelection(staging.cif)
                    )
                  }
                />
              </div>
            ),

            cif: staging.cif,
            name: staging.name,
            class_type: staging.class_type,
            stage: staging.stage,

            actions: (
              <div className="click">
                {staging.account_types && staging.account_types.length > 0 && (
                  <select
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      setSelectedType((prev) => ({
                        ...prev,
                        [staging.id]: selectedValue,
                      }));
                      setShowDetails((prev) => ({
                        ...prev,
                        [staging.id]: true,
                      }));
                    }}
                    value={selectedType[staging.id] || ""}
                  >
                    <option disabled value="">
                      Select account type
                    </option>
                    <optgroup label="Account Type">
                      {staging.account_types.map((item: any, index: number) => (
                        <option key={index} value={item.toLowerCase()}>
                          {item}
                        </option>
                      ))}
                    </optgroup>
                  </select>
                )}
              </div>
            ),
            actyion2: (
              <div>
                {showDetails[staging.id] && (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={
                      selectedType[staging.id] === "onbalance"
                        ? `/search-client?cif=${staging.cif}` +
                          (year ? `&year=${year}` : "") +
                          (quarter ? `&quarter=${quarter}` : "")
                        : selectedType[staging.id] === "offbalance"
                        ? `/search-client?cif=${staging.cif}` +
                          (year ? `&year=${year}` : "") +
                          (quarter ? `&quarter=${quarter}` : "") +
                          "&client_type=offbalance"
                        : `/search-client?cif=${staging.cif}` +
                          (year ? `&year=${year}` : "") +
                          (quarter ? `&quarter=${quarter}` : "") +
                          "&limits=yes&client_type=offbalance"
                    }
                  >
                    <i className="icon-info" style={{ color: "#333" }} />
                  </a>
                )}
              </div>
            ),
          };
        }
      });
    }

    return data;
  };

  // First fetch
  useEffect(() => {
    if (!state.isLoaded && !state.isFetching) fetchData(1);
  }, []);

  return (
    <>
      {state.isLoaded ? (
        <>
          {state.isFetching ? <WhiteboxLoader /> : ""}
          <form>
            <div className="filters">
              <div className="filter">
                <SelectField
                  placeholder="Filter"
                  options={[
                    { label: "All", value: "all" },
                    { label: "Has stage", value: "with" },
                    { label: "No stage", value: "without" },
                  ]}
                  onChange={(selected: any) => {
                    setFilter(selected);

                    console.log(selected);
                  }}
                  value={filter}
                />
              </div>
              <div className="filter" key="StagingFilter">
                <ClassesMenu
                  isClearable
                  value={classType}
                  onChange={(selected: any) => {
                    setClassType(selected);
                  }}
                  placeholder="Class Type"
                />
              </div>
              <div className="filter">
                <SelectField
                  isClearable
                  defaultValue={year ? { label: year, value: year } : undefined}
                  onChange={(selected: { value: number }) => {
                    setYear(selected?.value);
                  }}
                  placeholder={t("year")}
                  options={years}
                />
              </div>
              <div className="filter">
                <SelectField
                  isClearable
                  defaultValue={
                    quarter
                      ? { label: quarter?.toUpperCase(), value: quarter }
                      : undefined
                  }
                  onChange={(selected: {
                    value: "q1" | "q2" | "q3" | "q4";
                  }) => {
                    setQuarter(selected?.value);
                  }}
                  placeholder={t("quarter")}
                  options={[
                    { label: "Q1", value: "q1" },
                    { label: "Q2", value: "q2" },
                    { label: "Q3", value: "q3" },
                    { label: "Q4", value: "q4" },
                  ]}
                />
              </div>
            </div>
          </form>
          <TableActionBar
            title={t("staging")}
            search={search}
            showFilter={false}
          />

          {/* Client Stage */}
          {/*<ClientStage isOpen={isOpenEditStage} toggle={() => setIsOpenEditStage(false)} client_id={client.id}  year={selectedYear?.value} quarter={selectedQuarter?.value} class_type={client.class_type_id}  isUpdate={isUpdate} />  */}

          <ClientStage_Groupe
            isOpen={isOpenEditStage}
            toggle={() => {
              setIsOpenEditStage(false);
              dispatch(StagingSlice.actions.clearSelectedClients());
            }}
            client_id={state.selectedClients.map((cif) => cif.toString())}
            year={year}
            quarter={quarter}
            class_type={classType?.value}
            isUpdate={false}
          />

          {state.filtersComplete && Object.keys(generateData()).length > 0 ? (
            <div className="search-client-actions">
              <Row>
                <Col md={12}>
                  <Row>
                    {/* Client_Stage */}

                    <Col
                      md={6}
                      style={{
                        position: "sticky",
                        top: 11,
                        textAlign: "right",
                      }}
                      className="actions"
                    >
                      <button
                        className="button color-gold"
                        onClick={() => {
                          if (classType == undefined)
                            window.alert(
                              "Please you must select input type in the filter"
                            );
                          else setIsOpenEditStage(true);
                          setSelectedYear(selectedYear);
                          setSelectedQuarter(selectedQuarter);
                        }}
                      >
                        {t("Add Same Stage to Selected Clients")}
                      </button>
                      <span className="margin-10" />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          ) : (
            <></>
          )}

          {state.filtersComplete && Object.keys(generateData()).length > 0 ? (
            <DashboardTable
              ref={tableRef}
              header={[
                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                  <input
                    type="checkbox"
                    checked={
                      state.staging_list.length > 0 &&
                      state.staging_list.every((client) =>
                        state.selectedClients.includes(client.cif)
                      )
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        dispatch(StagingSlice.actions.selectAllClients());
                      } else {
                        dispatch(StagingSlice.actions.unselectAllClients());
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  />
                  <label style={{ margin: 0 }}>{t("Select")}</label>
                </div>,
                t("cif"),
                t("name"),
                t("class_type"),
                t("stage"),
                t("account_type"),
                "Details",
              ]}
              body={generateData()}
              selectable
              onSelect={() => {}}
              // loadMore={(page: number) => fetchData(page)}
              loadMore={(page: number) => fetchData(page, pageSize)}
              pagesCount={pagesCount}
            />
          ) : (
            <div className="center">
              <br /> <br />
              <br /> <br />
              <br /> <br />
              <br /> <br />
              <img src={select_vector} style={{ maxWidth: 500 }} />
              <p>Please select all filters</p>
            </div>
          )}
          {/* Pagination footer */}
          {state.filtersComplete && Object.keys(generateData()).length > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  width: 70,
                  zIndex: 9999,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  position: "relative",
                  top: "-45px",
                  marginLeft: "250px",
                }}
              >
                <PageSizeSelect
                  value={pageSize}
                  onChange={(val: number) => {
                    setPageSize(val);
                    tableRef.current?.reset();
                    fetchData(1, val);
                  }}
                  options={[
                    { label: "10", value: 10 },
                    { label: "20", value: 20 },
                    { label: "30", value: 30 },
                    { label: "50", value: 50 },
                    { label: "100", value: 100 },
                  ]}
                />
              </div>{" "}
            </div>
          )}
        </>
      ) : (
        <div className="center">
          <EllipsisLoader />
        </div>
      )}
    </>
  );
};
